/*
Purpose: list details of report with use datatable
Developer: BY KTH
Date:22/08/2023 
Project: TCMS
*/

import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";

import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import { Button as Buttonmui } from "@mui/material";
import axios from "axios";
import { security_key, BASE_URL } from "../global";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import LinearProgress from "@mui/material/LinearProgress";
import { useNavigate } from "react-router-dom";

function ReportFinanceDebtor() {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const columns = [
        {
            headerName: 'Student ID',
            field: "pk_student_id",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
              return `${params.row.pk_student_id && params.row.pk_student_id  != '' ? '#'+params.row.pk_student_id : '-'}`;
            },
        },
        {
            headerName: 'Student Name',
            field: "st_first_name",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.st_first_name && params.row.st_first_name != '' ? params.row.st_first_name+" "+params.row.st_surname : '-'}`;
            },
        },
        {
            headerName: "Parents / Guardians Name",
            field: "par_firstname",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.st_is_adultlearner === 1 ? 'Adult Learner' : params.row.par_firstname && params.row.par_firstname != '' ?  params.row.par_firstname+' '+params.row.par_surname : '-'}`;
            },
        },
        {
            headerName: "Deposit Online Amount Owing(" + (+sessionStorage.getItem('currency_code') != null && sessionStorage.getItem('currency_code') != '' ? sessionStorage.getItem('currency_code') : 'SGD') + ")",
            field: "online_deposit_owing_amount",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
              return `${params.row.online_deposit_owing_amount && params.row.online_deposit_owing_amount != '' ?  Number(params.row.online_deposit_owing_amount).toFixed(2) : (0).toFixed(2)}`;
            },
        },
        {
            headerName: "Deposit Offline Amount Owing(" + (+sessionStorage.getItem('currency_code') != null && sessionStorage.getItem('currency_code') != '' ? sessionStorage.getItem('currency_code') : 'SGD') + ")",
            field: "offline_deposit_owing_amount",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
              return `${params.row.offline_deposit_owing_amount && params.row.offline_deposit_owing_amount != '' ?  Number(params.row.offline_deposit_owing_amount).toFixed(2) : (0).toFixed(2)}`;
            },
        },
        {
            headerName: "Offline Amount Owing(" + (+sessionStorage.getItem('currency_code') != null && sessionStorage.getItem('currency_code') != '' ? sessionStorage.getItem('currency_code') : 'SGD') + ")",
            field: "offline_owing_amount",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
              return `${params.row.offline_owing_amount && params.row.offline_owing_amount != '' ?  Number(params.row.offline_owing_amount).toFixed(2) : (0).toFixed(2)}`;
            },
        },
        {
            headerName: "Online Amount Owing(" + (+sessionStorage.getItem('currency_code') != null && sessionStorage.getItem('currency_code') != '' ? sessionStorage.getItem('currency_code') : 'SGD') + ")",
            field: "online_owing_amount",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
              return `${params.row.online_owing_amount && params.row.online_owing_amount != '' ?  Number(params.row.online_owing_amount).toFixed(2) : (0).toFixed(2)}`;
            },
        },
        {
            headerName: "Total Amount Owing(" + (+sessionStorage.getItem('currency_code') != null && sessionStorage.getItem('currency_code') != '' ? sessionStorage.getItem('currency_code') : 'SGD') + ")",
            field: "amount",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                const totalOwing = params.row.total_owing_amount ? Number(params.row.total_owing_amount) : 0;
                const depositOwing = params.row.deposit_owing_amount ? Number(params.row.deposit_owing_amount) : 0;
                return (totalOwing + depositOwing).toFixed(2);
            },
        },
        {
            headerName: "Payment Gateway (Y/N)",
            field: "peyment",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
             return params.row.online_payment_verified > 0 ? 'Yes' : 'No'
            },
            renderCell: (params) => (
            <p className={`badge mb-0 ${params.row.online_payment_verified > 0 ? "cus-badge-Success" : "cus-badge-danger"}`}>
                {params.row.online_payment_verified > 0 ? "Yes" : "No"}
            </p>
            ),
        },
            {
        headerName: "Action",
        field: "action",
        headerClassName: "super-app-theme--header",
        flex: 1,
        disableExport: true,
        disableColumnFilter: false,
        disableColumnMenu: false,
        filterable: false,
        sortable: false,
        renderCell: (params) => (
            <Buttonmui
                variant="outlined"
                size="small"
                onClick={() =>
                    navigate("/report-finance-pending-payments", {
                        state: {
                            studentKey: params.row.fk_student_key,
                            studentLabel: `${params.row.st_first_name || ""} ${params.row.st_surname || ""}`.trim(),
                        },
                    })
                }
            >
                View/Pay
            </Buttonmui>
        ),
    },
        // {
        //     headerName: "Financial Assistance (Y/N)",
        //     field: "assistence",
        //     headerClassName: "super-app-theme--header",
        //     flex: 1,
        //     valueGetter: (params) => {
        //         return 'NA';
        //       },
        // },
    ];

    const [data, setItems] = useState([]);

    const [records, setRecords] = useState(data);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoading(true);

        try {
            const response = await axios.post(BASE_URL + "API/api_index.php", {
                security_key: security_key,
                //mode: "getDebtorReports",
                mode: "getDebtorReportCenter",
                fk_cent_key: sessionStorage.getItem("key"),
            });
          
            if (response.data.success === true) {
                setRecords(response.data.data);
                setItems(response.data.data);
                setLoading(false);
            } else {
                //alert message provide
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    return (
        <div className="">
            {/* --------------Page Start--------------- */}

            <div className="mb-3 d-flex justify-content-between align-items-center">
                <div>
                    <h5 className="page-title"> Debtor Reports </h5>

                    <div role="presentation">
                        <Breadcrumbs aria-label="breadcrumb" className="my-breadcrumbs">
                            <NavLink underline="hover" color="inherit" to="/calendar">
                                {" "}
                                Home
                            </NavLink>
                            <NavLink underline="hover" color="inherit" to="/reports">
                                {" "}
                                Reports
                            </NavLink>
                            <Typography color="text.primary">Debtor Reports </Typography>
                        </Breadcrumbs>
                    </div>
                </div>
                <div className="d-flex align-items-center gap-2">
                    {/* <Button onClick={() => navigate('/reports')} className="secondary-filled" variant="contained">
            Back
          </Button> */}
                </div>
            </div>
            {/* --------------Section Start--------------- */}

            <Card className="card my-card mb-3">
                <Card.Body>
                    {/* -------------Content Start--------------- */}

                    <Row>
                        <Col xs="12">
                            <div className="">
                                <Row className="justify-content-center">
                                    {/* --------------Table Content Start--------------- */}
                                    <Col sm={12}>
                                        <Box
                                            sx={{
                                                height: "fit-content",
                                                width: "100%",
                                                "& .actions": {
                                                    color: "text.secondary",
                                                },
                                                "& .textPrimary": {
                                                    color: "text.primary",
                                                },
                                                "& .super-app-theme--header": {
                                                    backgroundColor: "#f4f4f4",
                                                },
                                                "& .MuiDataGrid-row": {
                                                    border: "1px solid #eff0f2",
                                                },
                                                "& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus": {
                                                    outline: "none !important",
                                                },
                                                "& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-columnHeader:focus": {
                                                    outline: "none !important",
                                                },
                                            }}
                                            style={{ height: "100%", width: "100%" }}
                                        >
                                            <DataGrid
                                                sx={{
                                                    // disable cell selection style
                                                    ".MuiDataGrid-cell:focus": {
                                                        outline: "none",
                                                    },
                                                    // pointer cursor on ALL rows
                                                    "& .MuiDataGrid-row:hover": {
                                                        cursor: "pointer",
                                                    },
                                                }}
                                                //sx={{ border: "none", m: 2 }}
                                                autoHeight
                                                slots={{
                                                    loadingOverlay: LinearProgress,
                                                    //noRowsOverlay: CustomNoRowsOverlay,
                                                    toolbar: GridToolbar,
                                                    // toolbar: EditToolbar,
                                                }}
                                                slotProps={{
                                                    toolbar: {
                                                        csvOptions: { fileName: "DebtorReport" },
                                                        printOptions: {
                                                            pageStyle: `@media print {
                                                                            @page {
                                                                                size: A4 landscape;
                                                                                margin: 0;
                                                                            }
                                                                            }`,
                                                            disableToolbarButton: true,
                                                            hideFooter: true,
                                                            hideToolbar: true,
                                                            fileName: "DebtorReport",
                                                        },
                                                        records,
                                                        showQuickFilter: true,
                                                    },
                                                }}
                                                initialState={{
                                                    ...records.initialState,
                                                    pagination: { paginationModel: { pageSize: 10 } },
                                                }}
                                                showQuickFilter={true}
                                                pageSizeOptions={[10, 25, 50, 100]}
                                                loading={loading}
                                                rows={records.map((row, index) => ({ ...row, id: `row-${index}` }))}
                                                columns={columns}
                                                rowHeight={60}
                                                density="compact"
                                                disableRowSelectionOnClick
                                                showCellVerticalBorder={true}
                                                showColumnVerticalBorder={true}
                                            />
                                        </Box>
                                    </Col>
                                    {/* --------------Table Content Start--------------- */}
                                </Row>
                            </div>
                        </Col>
                    </Row>

                    {/* --------------Content End--------------- */}
                </Card.Body>
            </Card>

            {/* --------------Section End--------------- */}

            {/* --------------Page End--------------- */}
        </div>
    );
}

export default ReportFinanceDebtor;
